import { BudgetAPI } from "@griffingroupglobal/eslib-api";

const fetchBudgetHandler = async (signal, id) => {
  const { data } = await BudgetAPI.getById(id, { signal });

  return {
    lineItems: data?.lineItems,
    groups: data?.groups,
    metadata: data?.metadata,
    budgetType: data?.budgetType,
    summary: data?.summary,
    pendingUpdates: data?.pendingUpdates,
    budget: data,
    isLockGmp: data?.isLockGmp,
    isLockFixedFirm: data?.isLockFixedFirm,
  };
};

export default fetchBudgetHandler;
